<div class="row">
    <div class="col-lg-8">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="foremanScheduleNotificationsGrid"
                    #mainGrid
                    appAutoSize
                    (initialized)="grid.initialize(mainGrid)"
                    [itemsSource]="grid.view"
                    (selectionChanged)="getRecipients()"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Sent On'"
                        [binding]="'sentDate'"
                        [width]="175"
                        [format]="'MM/dd/yyyy hh:mm tt'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Type'" [binding]="'category'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="250"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Body'" [binding]="'body'" [width]="'2*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>

    <div class="col-lg-4" [hidden]="!grid.selectedItem">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="usersGrid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="usersGrid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="foremanScheduleNotificationRecipientsGrid"
                    #gridUsers
                    appAutoSize
                    (initialized)="usersGrid.initialize(gridUsers)"
                    [itemsSource]="usersGrid.view"
                    (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Recipient'"
                        [binding]="'displayName'"
                        [width]="'*'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Viewed'" [binding]="'viewed'" [width]="100"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Viewed Date'"
                        [binding]="'viewedDate'"
                        [width]="175"
                        [format]="'MM/dd/yyyy hh:mm tt'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
